import { connect } from 'react-redux';
import AuthModal from '../../components/AuthModal';
import { 
    loginRequest, 
    externalLoginRequest, 
    resetPassword, 
    updatePassword, 
    cleanErrorRegister,
    logoutUser
} from '../../actions/auth';
import { getNotifications } from '../../actions/notifications';

const mapStateToProps = (state: any) => ({
    fetchingUser: state.auth.fetching,
    errorUser: state.auth.error,
    externalLogin: state.auth.externalLogin,
    resetPasswordReducer: state.auth.resetPassword,
    updatePasswordReducer: state.auth.updatePassword,
    profile: state.auth.user?.profile?.code
});

const mapDispatchToProps = (dispatch: any) => ({
    loginRequest: (data: any) => dispatch(loginRequest(data)),
    externalLoginRequest: (provider: string, data: any) => dispatch(externalLoginRequest(provider, data)),
    resetPassword: (email: string) => dispatch(resetPassword(email)),
    updatePassword: (email: string, code: string, password: string) => dispatch(updatePassword(email, code, password)),
    cleanErrorRegister: () => dispatch(cleanErrorRegister()),
    logoutUser: () => dispatch(logoutUser()),
    getNotifications: () => dispatch(getNotifications())
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthModal);
